import { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import api from "../Services/api";
import ListAIAssistants from "./AIAssistant/List";
import ListAIEngines from "./AIEngine/List";
import AIEngineGroupList from "./AIEngineGroup/List";
import ListAIPrompts from "./AIPrompt/AIPromptList";
import SystemMailLogs from "./Admin/System/MailLogs/List";
import SystemNotifications from "./Admin/System/Notifications/List";
import SystemSettings from "./Admin/System/Settings/SystemSettings";
import UserList from "./Admin/Users/List";
import Blank from "./Blank";
import Chatbot from "./Chatbot/List";
import ClientDescriptionList from "./ClientDescription/List";
import ClientDesignList from "./ClientDesign/List";
import ListDatasets from "./Dataset/DatasetList";
import Login from "./Login";
import Logout from "./Logout";
import LogList from "./Logs/List";
import PageStats from "./PageStats/List";
import PromptExecutionHistoryList from "./PromptExecutionHistory/List";
import RedirectPage from "./RedirectPage";
import NotificationsList from "./Tests/Notifications/List";
import UserResetPassword from "./User/UserResetPassword";
import AIAnalytics from "./AIAnalytics";

const usePageTracking = (userProfile) => {
  const location = useLocation();

  useEffect(() => {
    if (!userProfile) return;

    const logPageView = async () => {
      try {
        const userActivity = {
          pageName: location.pathname,
          actionType: "View",
        };
        console.log(userActivity);
        await api.post('/api/user-activity/AddUserActivity', userActivity);
        console.log(`Page view logged: ${location.pathname}`);
      } catch (error) {
        console.error(`Error logging page view for ${location.pathname}:`, error);
      }
    };

    logPageView();
  }, [location, userProfile]);
};

const RenderAdmin = () => (
  <Switch>
    <Route path="/ai-engines" component={ListAIEngines} />
    <Route path="/aienginegroup" component={AIEngineGroupList}/>
    <Route path="/datasets" component={ListDatasets} />
    <Route path="/system/settings" component={SystemSettings} />
    <Route path="/system/notifications" component={SystemNotifications} />
    <Route path="/system/mail-logs" component={SystemMailLogs} />
    <Route path="/promptexecutionhistory" component={PromptExecutionHistoryList}/>
    <Route path="/tests/notifications" component={NotificationsList} />
    <Route path="/logs" component={LogList} />
    <Route path="/blank" component={Blank} />
    <Route path="/redirect" component={RedirectPage} />
    <Route path="/resetPassword" component={UserResetPassword} />
    <Route path="/logout" component={Logout} />
    <Route path="/users" component={UserList} />
    <Route path="/ai-assistants" component={ListAIAssistants} />
    <Route path="/ai-prompts" component={ListAIPrompts} />
    <Route path="/chatbot" component={Chatbot} />
    <Route path="/pagestats" component={PageStats} />
    <Route path="/client-descriptions" component={ClientDescriptionList} />
    <Route path="/client-designs" component={ClientDesignList} />
    <Route path="/ai-analytics" component={AIAnalytics} />
    <Route component={RedirectPage} />
  </Switch>
);
const RenderPowerUser = () => (
  <Switch>
    <Route path="/system/settings" component={SystemSettings} />
    <Route path="/system/notifications" component={SystemNotifications} />
    <Route path="/system/mail-logs" component={SystemMailLogs} />
    <Route path="/promptexecutionhistory" component={PromptExecutionHistoryList}/>
    <Route path="/tests/notifications" component={NotificationsList} />
    <Route path="/blank" component={Blank} />
    <Route path="/redirect" component={RedirectPage} />
    <Route path="/resetPassword" component={UserResetPassword} />
    <Route path="/logout" component={Logout} />
    <Route path="/datasets" component={ListDatasets} />
    <Route path="/ai-assistants" component={ListAIAssistants} />
    <Route path="/ai-prompts" component={ListAIPrompts} />
    <Route path="/chatbot" component={Chatbot} />
    <Route path="/pagestats" component={PageStats} />
    <Route path="/client-descriptions" component={ClientDescriptionList} />
    <Route path="/client-designs" component={ClientDesignList} />
    <Route path="/ai-analytics" component={AIAnalytics} />
    <Route component={RedirectPage} />
  </Switch>
);

const RenderUser = () => (
  <Switch>
    <Route path="/blank" component={Blank} />
    <Route path="/redirect" component={RedirectPage} />
    <Route path="/promptexecutionhistory" component={PromptExecutionHistoryList}/>
    <Route path="/resetPassword" component={UserResetPassword} />
    <Route path="/logout" component={Logout} />
    <Route path="/users" component={UserList} />
    <Route path="/ai-assistants" component={ListAIAssistants} />
    <Route path="/ai-prompts" component={ListAIPrompts} />
    <Route path="/chatbot" component={Chatbot} />
    <Route path="/pagestats" component={PageStats} />
    <Route path="/client-descriptions" component={ClientDescriptionList} />
    <Route path="/client-designs" component={ClientDesignList} />
    <Route component={RedirectPage} />
  </Switch>
);

export default function RenderRouter({ userProfile }) {
  usePageTracking(userProfile);
  return userProfile === null ? (
    <Switch>
      <Route path="/redirect" component={RedirectPage} />
      <Route path="/login" component={Login} />
      <Route path="/resetPassword" component={UserResetPassword} />
      <Route component={RedirectPage} />
    </Switch>
  ) : (
    {
      Admin: <RenderAdmin />,
      PowerUser: <RenderPowerUser />,
      User: <RenderUser />
    }[userProfile.role]
  );
}
